/* global axios */
import ApiClient from './ApiClient';

// Traduzione del testo dell'agente via backend (DeepSeek). Il browser manda solo il
// testo: la chiave del provider resta lato server.
class TranslateAPI extends ApiClient {
  constructor() {
    super('translate', { accountScoped: true });
  }

  translate({ content, sourceLang = 'Italian', targetLang = 'English' }) {
    // Timeout esplicito: se il backend resta appeso (provider lento) la richiesta
    // fallisce e il pulsante si sblocca, invece di girare all'infinito.
    return axios.post(
      this.url,
      {
        content,
        source_lang: sourceLang,
        target_lang: targetLang,
      },
      { timeout: 60000 }
    );
  }
}

export default new TranslateAPI();
